// extracted by mini-css-extract-plugin
export default {"blogPostList":"styles_blogPostList__mSG5Q","blogPostListDescription":"styles_blogPostListDescription__-aGby"};